/* Sale countdown + cart savings flash.
   Reads the end date from every [data-sale-end] (theme setting "sale_end").
   When the date passes, each timer hides itself: nothing resets, nothing is faked. */
(() => {
  if (window.__spongeUrgency) return;
  window.__spongeUrgency = true;
  const pad = (n) => String(n).padStart(2, '0');

  const tick = () => document.querySelectorAll('[data-sale-end]').forEach((el) => {
    const end = new Date(el.dataset.saleEnd);
    const left = end - Date.now();
    const out = el.querySelector('[data-timer]');
    if (isNaN(end) || left <= 0 || !out) { el.hidden = true; return; }
    const s = Math.floor(left / 1000);
    const d = Math.floor(s / 86400);
    out.textContent = (d ? d + 'd ' : '') + [Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60].map(pad).join(':');
    el.hidden = false;
  });
  /* shorter guarantee box + an urgency line next to the buy button (only while a timer is running).
     The text is only replaced if it still has the original wording, so edits made in the editor win. */
  const tidy = () => {
    document.querySelectorAll('.pdp__guarantee-title').forEach((t) => {
      if (t.textContent.trim() !== '30-Day Guarantee, free with 2+') return;
      t.textContent = '30-Day Guarantee';
      const body = t.parentElement && t.parentElement.querySelector('.rte');
      if (body) body.innerHTML = '<p>Free with 2+ projectors.</p>';
    });
    const live = [...document.querySelectorAll('.pd-urgency[data-sale-end], .ub[data-sale-end]')].some((n) => !n.hidden);
    document.querySelectorAll('.pdp__buy-note').forEach((n) => {
      let s = n.querySelector('.pdp__urgent');
      if (live && !s) {
        s = document.createElement('span');
        s.className = 'pdp__urgent';
        s.textContent = ' · Launch offer ends when the timer hits zero';
        n.append(s);
      }
      if (s) s.hidden = !live;
    });
  };
  setInterval(() => { tick(); tidy(); }, 1000);
  tick();
  tidy();

  /* replay the "you're saving" banner for a few seconds each time the cart opens or updates */
  const flash = () => {
    const b = document.querySelector('.cd__save');
    if (!b) return;
    b.classList.remove('is-flash');
    void b.offsetWidth;
    b.classList.add('is-flash');
  };
  let wasOpen = false;
  new MutationObserver(() => {
    const d = document.getElementById('CartDrawer');
    const open = !!d && d.classList.contains('is-open');
    if (open && !wasOpen) flash();
    wasOpen = open;
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
  document.addEventListener('cart:updated', () => setTimeout(flash, 60));
})();
